import { isEmpty, path } from 'ramda';

export function daomainsValidator(state, configKey, selectedApp, PATHS) {
	const absolutePath = [
		'configDraft',
		'byKey',
		configKey,
		'query',
		'qry.tenant.get-full',
		'data',
		'private',
		'apps',
		selectedApp,
		...PATHS[0],
	];
	const arrayToCheck = path(absolutePath, state);

	if (!arrayToCheck || isEmpty(arrayToCheck)) return false;

	if (arrayToCheck.indexOf('') === -1) return false;

	return true;
}
